import React from "react"

import Icon from "../../images/check-thin-sm.svg"

import styles from "./Radio.module.css"

const Radio = props => (
  <span className={styles.container}>
    <input
      type="radio"
      id={props.id}
      name={props.name}
      value={props.value}
      className={styles.input}
      checked={props.checked}
      required={props.required}
    />
    <Icon className={styles.icon} aria-hidden="true" />
  </span>
)

export default Radio
